import { useEffect, useState } from 'react';
import api from '../../services/api';

interface Status { configured?: boolean; cooldown_active?: boolean; cooldown_until?: string; }

export default function TelegramCollectionStatus() {
    const [status, setStatus] = useState<Status>({});
    const [error, setError] = useState(false);
    useEffect(() => {
        let active = true;
        const refresh = () => api.get('/scrapers/telegram/collection-status')
            .then(r => { if (active) { setStatus(r.data); setError(false); } })
            .catch(() => { if (active) setError(true); });
        void refresh();
        const timer = setInterval(() => void refresh(), 60000);
        return () => { active = false; clearInterval(timer); };
    }, []);
    if (error) return <p role="status" className="text-xs text-muted-foreground">Collection status is unavailable.</p>;
    if (status.configured === false) return <p role="status" className="text-sm text-amber-700 dark:text-amber-400">Telegram collection needs a configured session. Retained messages remain available.</p>;
    if (!status.cooldown_active) return null;
    return <p role="status" className="rounded-lg border border-amber-500/30 bg-amber-500/10 p-3 text-sm">
        Telegram requested a collection pause until {status.cooldown_until ? new Date(status.cooldown_until).toLocaleString('en-IN') : 'the cooldown ends'}.
        {' '}Collection jobs will defer during this period. Retained messages and analysis remain available.
    </p>;
}
